import React from "react";
import { AccessEnum } from "~/api/GeneratedApi";
import { useAccess } from "./useAccess";

export function useOnlyTLReadAccess() {
  const { accesses, accessesSet } = useAccess();
  const [readOnlyBuoyOnlyUser, setReadOnlyBuoyOnlyUser] = React.useState(false);

  React.useEffect(() => {
    if (!accessesSet) return;
    const accessArray = Object.keys(accesses).filter(
      (a) => accesses[a as unknown as AccessEnum],
    );
    const onlyTLReadAccess =
      accessArray.length === 1 && accesses[AccessEnum.TrafficLightBuoyRead];
    setReadOnlyBuoyOnlyUser(onlyTLReadAccess);
  }, [accesses, accessesSet]);

  return readOnlyBuoyOnlyUser;
}
